// extracted by mini-css-extract-plugin
module.exports = {"topSelling":"TopSelling_topSelling__1KeI0","topSellingProducts":"TopSelling_topSellingProducts__2vH-7"};